import { test, expect } from "@playwright/test";
import { V3 } from "../../lib/v3/v3.js";
import { captureHybridSnapshot } from "../../lib/v3/understudy/a11y/snapshot/index.js";
import { v3TestConfig } from "./v3.config.js";

test.describe("tests captureHybridSnapshot() does not break due to -32000 Failed to convert response to JSON: CBOR: stack limit exceeded", () => {
  let v3: V3;

  test.beforeEach(async () => {
    v3 = new V3(v3TestConfig);
    await v3.init();
  });

  test.afterEach(async () => {
    await v3?.close?.().catch(() => {});
  });

  test("captureHybridSnapshot does not throw", async () => {
    const page = v3.context.pages()[0];

    await page.goto(
      "https://browserbase.github.io/stagehand-eval-sites/sites/nested-div/",
    );

    await expect(captureHybridSnapshot(page)).resolves.toBeDefined();
  });
});
